module.exports = __webpack_public_path__ + "static/img/homePlan5.65b5a7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/homePlan5.png
// module id = pHug
// module chunks = 3